import {createContext} from "react";

import type {NotificationState} from "./reducer.ts";

// Create a context for Khanmigo notifications
export const NotificationStateContext = createContext<NotificationState | null>(
    null,
);
